import { useLocalLogic } from "~/context/LocalLogicProvider";
import { useQuery } from "@tanstack/react-query";
import { useFlags } from "launchdarkly-react-client-sdk";

import { schoolsKeys, schoolsResponse } from "~/features/schools";

import type { Schools } from "@local-logic/client";

type Options = {
  lat?: number;
  lng?: number;
  limit?: number;
  include?: (keyof Schools)[];
  radius?: number;
  includeCatchments?: boolean;
};

export function useSchools({
  lat,
  lng,
  include,
  radius = 2000,
  limit = 30,
  includeCatchments = false,
}: Options) {
  const flags = useFlags();
  const { client } = useLocalLogic();

  const options = {
    lat,
    lng,
    limit,
    attemptMinimum: flags.lcMinimumPoi ? 3 : undefined,
    radius,
    include,
    include_catchments: includeCatchments,
  };

  return useQuery({
    queryKey: schoolsKeys.list(options),
    queryFn: async () =>
      client.getSchools(options as unknown as schoolsResponse),
    enabled:
      !!options && !!options.include?.length && !!options.lat && !!options.lng,
  });
}
